'use strict'

import CloudDataConnector from '../api.js'
import Plot from './base.js'

export default class PlotGreeneryYearly extends Plot {
  constructor () {
    super('greenery-yearly')
  }

  async dataFunction (controller) {
    // Get data from API
    const greeneryResponse = await new CloudDataConnector().getGreeneryYearly(controller.uiElements.station.val())
    const height = controller.uiParams.height

    const greeneryData = greeneryResponse.sort((left, right) => left.year < right.year ? -1 : (left.year > right.year ? 1 : 0))

    const greeneryDataPoints = greeneryData.map(item => item.greenness_index)
    const xaxis = greeneryData.map(item => item.year)

    // Return elements to give to Plotly
    return {
      data: [
        {
          x: xaxis,
          y: greeneryDataPoints,
          type: 'lines+marker',
          marker: { color: '#ffac2b', size: 8 },
          line: { color: '#ffac2b', width: 1 }
        }
      ],
      layout: {
        xaxis: { title: 'Année', autotick: false },
        yaxis: { title: 'Date de début de verdissement' },
        margin: { t: 0 },
        height
      }
    }
  }
}
